/* src/app/modules/ct-status/components/cts-gantry-log-detail/cts-gantry-log-detail.component.scss */
:host {
  display: block;
}
.flex-row {
  display: flex;
  flex-flow: row nowrap;
  gap: 1rem;
  align-items: center;
}
header sh-text {
  width: max-content;
}
.header--wrap {
  flex-wrap: wrap;
  margin-bottom: 0.8rem;
}
.header--wrap .space {
  flex: 1;
}
.table-group {
  position: relative;
  overflow: hidden;
  height: 100%;
}
.table-group .table-container {
  height: 100%;
}
.table-group .table-container sh-table {
  width: 100%;
  min-width: max-content;
  height: calc(90vh - 123px - 72px);
}
.table-group__filter {
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: 0.25rem;
  z-index: 2;
}
.table-group__filter sh-icon {
  color: rgb(var(--ui-5));
}
.table-group__filter sh-input-text {
  width: 15rem;
}
.table-group__filter .checkbox-filters {
  gap: 1rem;
  align-items: center;
}
.table-group__filter .checkbox-filters sh-checkbox {
  white-space: nowrap;
}
@media only screen and (max-width: 1120px) {
  .table-group__filter {
    position: inherit;
    top: inherit;
    margin-bottom: 0.25rem;
  }
}
@media only screen and (max-width: 1600px) {
  .table-group .table-container {
    overflow-x: scroll;
    height: 100%;
  }
  .table-group .table-container sh-table {
    width: 100%;
    min-width: max-content;
    height: calc(85vh - 72px);
  }
}
.severity-icon {
  margin-top: 0.25rem;
  margin-left: 0.75rem;
}
.row--error {
  background: rgba(231, 0, 29, 0.05);
}
.datetime-cell {
  display: flex;
  height: inherit;
}
/*# sourceMappingURL=cts-gantry-log-detail.component.css.map */
